import { useEffect, useState } from "react";
import { API } from "aws-amplify";
import {
    Alert,
    Button,
    Col,
    Divider,
    Popconfirm,
    Row,
    Space,
    Spin,
    Typography,
} from "antd";
import {
    DeleteOutlined,
    LoadingOutlined,
    ReloadOutlined,
} from "@ant-design/icons";

import SLSchedule from "./SLSchedule";
import SLParticipants from "./SLParticipants";
import SLPDF from "./SLPDF";
import SLTXT from "./SLTXT";
import TestUpload from "./TestUpload";

const { Title } = Typography;

const initialData = {
    startGroups: [],
    startlist: {},
};

function StartList(props) {
    const [data, setData] = useState(initialData);
    const [sortedParticipants, setSortedParticipants] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getSortedParticipants = () => {
            //console.log(props.allParticipants);
            //console.log(props.startGroups);
            //console.log(data.startGroups);
            return props.startGroups.map((sg) => {
                const res = props.allParticipants.reduce(
                    (participants, participant) => {
                        const thisStartGroup = data.startGroups.reduce(
                            (result, thisSg) => {
                                if (sg.id === thisSg.id) {
                                    result = thisSg;
                                }
                                return result;
                            },
                            {},
                        );
                        participants.dance = thisStartGroup.dance;
                        if (participant.startGroup === sg.id) {
                            let orderIndex = -1;
                            if (thisStartGroup.order) {
                                //console.log(participant.association + "::" + participant.id, thisStartGroup.order);
                                orderIndex = thisStartGroup.order.indexOf(
                                    participant.association +
                                        "::" +
                                        participant.id,
                                );
                            }
                            //console.log(orderIndex);
                            if (orderIndex !== -1) {
                                participants.ordered[orderIndex] = {
                                    ...participant,
                                    position: orderIndex + 1,
                                };
                            } else {
                                participants.unordered.push({
                                    ...participant,
                                    position: null,
                                });
                            }
                        }
                        return participants;
                    },
                    { unordered: [], ordered: [] },
                );
                return {
                    sg: sg.id,
                    // override at GDD only! TODO: adjust year
                    title:
                        sg.id === 6
                            ? "Altersklasse 6 (über 24 Jahre; Jahrg. ab 2002)"
                            : sg.name,
                    //title: sg.name,
                    dance: res.dance,
                    list: [...res.unordered, ...res.ordered],
                };
            });
        };

        setSortedParticipants(getSortedParticipants());
    }, [data, props.allParticipants, props.startGroups]);

    const autoOrder = async (sg) => {
        //console.log("autoOrder", sg);
        const data = await API.post("ddppanm0a", "/startlist", {
            body: { autoOrder: { sg: sg } },
        });
        setData(data);
    };

    const getData = async () => {
        setLoading(true);
        const data = await API.get("ddppanm0a", "/startlist");
        //console.log(data);
        setData(data);
        setLoading(false);
    };

    const onAddAgendaItem = async (cmd) => {
        const data = await API.post("ddppanm0a", "/startlist", {
            body: { add: cmd },
        });
        setData(data);
    };

    const onChangeDance = (key, event) => {
        data.startGroups[key].dance = event.target.value;
        setData({ ...data });
    };

    const onChangeStage = (key, stage) => {
        data.startGroups[key].stage = stage === "stage2" ? 2 : 1;
        setData({ ...data });
    };

    const onChangeOrder = async (sg, id, association, pos) => {
        //console.log("onChangeOrder:", sg, id, association, pos);
        const data = await API.post("ddppanm0a", "/startlist", {
            body: {
                pos: {
                    sg: sg,
                    id: id,
                    association: association,
                    pos: pos,
                },
            },
        });
        //console.log(data);
        setData(data);
    };

    const onDelete = async (cmd) => {
        //console.log("delete: ", cmd);
        const data = await API.post("ddppanm0a", "/startlist", {
            body: { del: cmd },
        });
        //console.log(data);
        setData(data);
    };

    const onMove = async (cmd) => {
        const data = await API.post("ddppanm0a", "/startlist", {
            body: { move: cmd },
        });
        setData(data);
    };

    const onSave = async (cmd) => {
        //console.log("save: ", cmd);
        const data = await API.post("ddppanm0a", "/startlist", {
            body: { stage: cmd },
        });
        //console.log(data);
        setData(data);
    };

    const onSaveConf = async (cmd) => {
        //console.log("save conf: ", cmd);
        const data = await API.post("ddppanm0a", "/startlist", {
            body: { conf: cmd },
        });
        //console.log(data);
        setData(data);
    };

    const resetStartList = async () => {
        const data = await API.del("ddppanm0a", "/startlist");
        //console.log(data);
        setData(data);
    };

    const overrideData = (data) => {
        // only for GDD! TODO: adjust year
        const startGroups = data.startGroups.reduce((prev, cur) => {
            if (cur.id != 7 && cur.id != 8) {
                if (cur.id == 6) {
                    cur.name = "Altersklasse 6 (über 24 Jahre; Jahrg. ab 2002)";
                }
                prev.push(cur);
            }
            return prev;
        }, []);
        const sgs = data?.sgs?.reduce((prev, cur) => {
            if (cur != 7 && cur != 8) {
                prev.push(cur);
            }
            return prev;
        }, []);
        return { ...data, startGroups: startGroups, sgs: sgs };
        //return data;
    };

    return (
        <>
            <Divider />
            <Row style={{ textAlign: "center" }}>
                <Col span={24}>
                    <Title level={2}>Startliste</Title>
                </Col>
            </Row>
            <Row style={{ textAlign: "center" }}>
                <Col span={24}>
                    <Space>
                        <Button
                            icon={
                                loading ? (
                                    <LoadingOutlined />
                                ) : (
                                    <ReloadOutlined />
                                )
                            }
                            onClick={getData}
                            type="primary"
                        >
                            Aktualisieren
                        </Button>
                        <SLPDF
                            data={overrideData(data)}
                            sortedParticipants={sortedParticipants}
                        />
                        <SLTXT
                            data={overrideData(data)}
                            sortedParticipants={sortedParticipants}
                        />
                        <Popconfirm
                            title="Wirklich alle Startlisten-Daten zurücksetzen?"
                            cancelText="Abbrechen"
                            okText="Zurücksetzen"
                            onConfirm={resetStartList}
                        >
                            <Button
                                danger={true}
                                icon={<DeleteOutlined />}
                                type="primary"
                            >
                                Zurücksetzen
                            </Button>
                        </Popconfirm>
                        {props.env.testData ? (
                            <TestUpload uploadTestData={props.uploadTestData} />
                        ) : (
                            <></>
                        )}
                    </Space>
                </Col>
            </Row>
            {data.startGroups.length === 0 ? (
                <Alert
                    type="info"
                    showIcon={true}
                    closable={true}
                    message='Bitte "Aktualisieren", um Startlisten-Daten anzuzeigen...'
                    style={{ marginTop: 20 }}
                />
            ) : (
                <Spin size="large" spinning={loading}>
                    <SLSchedule
                        data={overrideData(data)}
                        onAddAgendaItem={onAddAgendaItem}
                        onChangeDance={onChangeDance}
                        onChangeStage={onChangeStage}
                        onDelete={onDelete}
                        onMove={onMove}
                        onSave={onSave}
                        onSaveConf={onSaveConf}
                    />
                    <SLParticipants
                        participants={sortedParticipants}
                        onChangeOrder={onChangeOrder}
                        autoOrder={autoOrder}
                    />
                </Spin>
            )}
        </>
    );
}

export default StartList;
